import { fadeIn, fadeOut } from '@/components/toast'
import { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'

const GlobalStyle = createGlobalStyle`
${normalize}
html,body {
  padding: 0;
  margin: 0;
  background: #fff;
  font-family: Roboto-Regular,Helvetica,Arial,sans-serif;
}
button, input, video {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
}

@font-face {
  font-family: Roboto-Bold;
  src: url("https://static.kreditpintar.com/k8s-kp-website/fonts/Roboto-Bold.ttf?display=optional");
  font-display: swap;
}
@font-face {
  font-family: Roboto-Medium;
  src: url("https://static.kreditpintar.com/k8s-kp-website/fonts/Roboto-Medium.ttf?display=optional");
  font-display: swap;
}
@font-face {
  font-family: Roboto-Regular;
  src: url("https://static.kreditpintar.com/k8s-kp-website/fonts/Roboto-Regular.ttf?display=optional");
  font-display: swap;
}

@font-face {
  font-family: Inter;
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/inter/v19/UcCo3FwrK3iLTcviYwYZ8UA3.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

.fade-in {
  animation: ${fadeIn} 0.3s ease forwards;
}

.fade-out {
  animation: ${fadeOut} 0.3s ease forwards;
}

a {
  color: inherit;
  text-decoration: none;
}

* {
  box-sizing: border-box;
}

#nprogress .bar { 
  background: #1cc812 !important;
} 
`

export default GlobalStyle
